import React, { FC } from 'react';

import { Divider, type DividerProps } from 'antd';

export interface ModalDividerProps extends Omit<DividerProps, 'type'> {
  type: 'top' | 'bottom';
}

export const ModalDivider: FC<ModalDividerProps> = ({ type, ...props }) => {
  return (
    <Divider
      {...props}
      style={{
        margin: type === 'top' ? '12px 0 20px' : '20px 0 12px',
        width: 'calc(100% + 48px)',
        position: 'relative',
        left: '-24px',
      }}
    />
  );
};
